export const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
export const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,50}$/;

const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const SPECIAL = `!@#$%^&*()-_=+[]{};:'",.<>/?\\|~\``;
const ALL = LOWER + UPPER + DIGITS + SPECIAL;

function randIndex(max) {
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const buf = new Uint32Array(1);
    window.crypto.getRandomValues(buf);
    return buf[0] % max;
  }
  return Math.floor(Math.random() * max);
}
const randChar = (pool) => pool[randIndex(pool.length)];

export function generateRandomPassword(len = 8) {
  const length = Math.max(8, len);
  const must = [randChar(LOWER), randChar(UPPER), randChar(DIGITS), randChar(SPECIAL)];
  const rest = Array.from({ length: length - must.length }, () => randChar(ALL));
  const chars = [...must, ...rest];

  for (let i = chars.length - 1; i > 0; i--) {
    const j = randIndex(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  const pwd = chars.join("");
  return PASSWORD_REGEX.test(pwd) ? pwd : generateRandomPassword(length);
}


export const timeSince = (date) => {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes ago";
  }
  return Math.floor(seconds) + " seconds ago";
};

export const checkNullValue= (obj) => {
  return Object.entries(obj)
    .filter(([key]) => key !== "id")
    .every(([key, value]) => value === null || value ===undefined);
};


export const bytesToSize = (bytes) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

export const humanize = (str) => {
  var i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
};

export const to_snake_case = (str) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join("_");

export const removeAtIndex = (arr, index) => {
  const copy = [...arr];
  copy.splice(index, 1);
  return copy;
};

export const throwError = function({ message = "", status = 400 }) {
  let errorObject = new Error(message);
  errorObject.status = status;
  return errorObject;
};

export const toggle = (arr, items, getValue = (item) => item) => {
  if (Array.isArray(items)) {
    let updatedArray = [...arr];
    items.forEach((item) => {
      const index = updatedArray.findIndex(
        (i) => getValue(i) === getValue(item)
      );
      if (index === -1) {
        updatedArray.push(item); 
      } else {
        updatedArray = removeAtIndex(updatedArray, index); 
      }
    });
    return updatedArray;
  } else {
    const index = arr.findIndex((i) => getValue(i) === getValue(items));
    if (index === -1) return [...arr, items];
    return removeAtIndex(arr, index);
  }
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const isoToDate = (isoformat, full = false) => {
  let options = {};
  if (full) {
    options = {
      weekday: "long",
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
  } else {
    options = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
  }
  const the_date = new Date(isoformat);

  return the_date.toLocaleString("en-US", options);
};

export const handleKeyDown = (e) => {
  if (
    e.keyCode === 38 ||
    e.keyCode === 40 ||
    ["e", "E", "+", "-"].includes(e.key)
  ) {
    e.preventDefault();
  }
};

export const isTimeValid = (val) => {
  var _slicedToArray = (function() {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;
      try {
        for (
          var _i = arr[Symbol.iterator](), _s;
          !(_n = (_s = _i.next()).done);
          _n = true
        ) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    return function(arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance"
        );
      }
    };
  })();

  var letterArr = val
      .split(":")
      .join("")
      .split(""),
    regexp = /^\d{0,2}?\:?\d{0,2}$/,
    valArr = [];

  var _val$split = val.split(":");

  var _val$split2 = _slicedToArray(_val$split, 2);

  var hoursStr = _val$split2[0];
  var minutesStr = _val$split2[1];

  if (!regexp.test(val)) {
    return false;
  }

  var hours = Number(hoursStr);
  var minutes = Number(minutesStr);

  var isValidHour = function isValidHour(hour) {
    return Number.isInteger(hours) && hours >= 0 && hours < 100;
  };
  var isValidMinutes = function isValidMinutes(minutes) {
    return (
      (Number.isInteger(minutes) && hours >= 0 && hours < 100) ||
      Number.isNaN(minutes)
    );
  };
  if (!isValidHour(hours) || !isValidMinutes(minutes)) {
    return false;
  }

  if (minutes < 10 && Number(minutesStr[0]) > 5) {
    return false;
  }

  if (valArr.indexOf(":")) {
    valArr = val.split(":");
  } else {
    valArr.push(val);
  }

  // check mm and HH
  if (
    valArr[0] &&
    valArr[0].length &&
    (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 99)
  ) {
    return false;
  }

  if (
    valArr[1] &&
    valArr[1].length &&
    (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59)
  ) {
    return false;
  }

  return true;
};
